import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMappingsColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_11310_202460)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 29.5,
				cy: 10.5,
				r: 2.5,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 29.5,
				cy: 20,
				r: 2.5,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 29.5,
				cy: 29.5,
				r: 2.5,
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14 16.9999L8 16.9999L8 22.9999L14 22.9999L14 21.7291C14.0708 21.8018 14.1438 21.8769 14.2184 21.954C14.9625 22.7222 15.8649 23.6758 16.5282 24.4456C17.0194 25.0158 17.3153 25.5748 17.6388 26.186C17.7481 26.3924 17.8605 26.6048 17.9847 26.8256C18.4652 27.6802 19.0763 28.5408 20.2774 29.1394C21.0981 29.5485 22.1842 29.7149 22.9884 29.7892C23.4052 29.8277 23.7759 29.8438 24.0428 29.8503C24.1765 29.8536 24.285 29.8544 24.3611 29.8545C24.3991 29.8545 24.4291 29.8543 24.4502 29.8541L24.475 29.8538L24.4822 29.8537L24.4855 29.8537C24.9273 29.8453 25.2789 29.4804 25.2705 29.0387C25.2622 28.597 24.8971 28.2458 24.4555 28.2539L24.452 28.254L24.4348 28.2542C24.4189 28.2543 24.3944 28.2545 24.362 28.2545C24.2973 28.2545 24.2016 28.2537 24.0818 28.2508C23.8417 28.2449 23.5081 28.2304 23.1356 28.196C22.3613 28.1244 21.5292 27.9756 20.9911 27.7074C20.1996 27.3129 19.7872 26.7669 19.3793 26.0414C19.292 25.8863 19.2024 25.7164 19.1072 25.5359L19.1071 25.5357L19.1071 25.5357C18.7693 24.8954 18.3612 24.1219 17.7403 23.4012C17.0452 22.5945 16.1158 21.6132 15.3677 20.8408L15.3281 20.8L25.2 20.8C25.6418 20.8 26 20.4418 26 20C26 19.5582 25.6418 19.2 25.2 19.2L15.4369 19.2C15.8761 18.7282 16.3482 18.2149 16.7327 17.7817C17.4901 16.9286 17.9993 16.0052 18.4311 15.2222L18.4312 15.2221L18.4312 15.2221L18.4313 15.2219C18.5635 14.9821 18.6885 14.7554 18.8112 14.548C19.3479 13.6402 19.9038 12.9453 20.9562 12.4831C21.5305 12.2308 22.3844 12.0821 23.1563 12.0022C23.5302 11.9635 23.8636 11.9429 24.1032 11.9321C24.2228 11.9266 24.3183 11.9237 24.383 11.922C24.4153 11.9212 24.4399 11.9208 24.456 11.9205L24.4734 11.9203L24.4774 11.9202C24.919 11.9165 25.2744 11.5555 25.2709 11.1138C25.2673 10.672 24.9062 10.3167 24.4644 10.3203L24.4709 11.1202C24.4644 10.3203 24.4633 10.3203 24.4632 10.3203L24.4611 10.3203L24.4542 10.3204L24.4302 10.3207C24.4097 10.3211 24.3804 10.3216 24.3431 10.3225C24.2687 10.3244 24.1622 10.3277 24.0307 10.3337C23.7681 10.3456 23.4031 10.3681 22.9916 10.4107C22.1929 10.4934 21.1286 10.6598 20.3128 11.0182C18.8242 11.6719 18.0513 12.6894 17.4339 13.7337C17.2674 14.0153 17.1161 14.2892 16.9678 14.5575C16.554 15.3065 16.1642 16.0121 15.5362 16.7195C15.0853 17.2274 14.5044 17.8555 14 18.3946L14 16.9999ZM24.4855 29.8537C24.4857 29.8537 24.4858 29.8537 24.4707 29.0538L24.4855 29.8537Z",
				fill: "url(#paint0_linear_11310_202460)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_11310_202460",
		x1: 25.3081,
		y1: 28.6918,
		x2: 6.22195,
		y2: 12.2422,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .00183952,
				stopColor: "#53BCDE"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .368179,
				stopColor: "#767CFF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .645971,
				stopColor: "#AC8EFF"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11310_202460",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(8 32) rotate(-90)"
		})
	})] })]
});
export default SvgMappingsColored;
